import { QueryClient } from '@tanstack/react-query'

/**
 * Cliente único do TanStack Query. Sem novas tentativas automáticas: o painel
 * antigo mostrava o erro na hora, e as páginas decidem o que exibir.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
